import React from 'react';
import { IconProps } from '.';

const SvgCategoryBeauty = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15.75.56V11h-1.5V3.44l-4.5 3.15V11h-1.5V5.81l7.5-5.25ZM6.25 13.25h11.5v9.5H6.25v-9.5Zm1.5 1.5v6.5h8.5v-6.5h-8.5Z'
        clipRule='evenodd'
      />
      <path fill={color} fillRule='evenodd' d='M7.25 10.25h9.5V14h-1.5v-2.25h-6.5V14h-1.5v-3.75Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgCategoryBeauty;
